import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import {
	GeoJsonFormat,
	GeoJsonResult,
	GeoJsonState,
	GeoJsonType,
} from '@localTypes/geoJson';

const initialState: GeoJsonState = {};

export const geoJsonSlice = createSlice({
	initialState,
	name: 'geo_json',
	reducers: {
		clearAllGeoJson: () => ({}),
		clearGeoJson: (state, action: PayloadAction<{
			id_key: string;
		}>) => {
			const {
				id_key,
			} = action.payload;
			delete state[id_key];
		},
		setGeoJson: (state, action: PayloadAction<{
			format: GeoJsonFormat;
			id_key: string;
			ids: number[];
			result: GeoJsonResult;
			type: GeoJsonType;
		}>) => {
			const {
				id_key,
				result,
			} = action.payload;

			state[id_key] = {
				isError: false,
				isLoading: false,
				result,
			};
		},
		setGeoJsonError: (state, action: PayloadAction<{
			format: GeoJsonFormat;
			id_key: string;
			ids: number[];
			isError: boolean;
			type: GeoJsonType;
		}>) => {
			const {
				id_key,
				isError,
			} = action.payload;
			if (!state[id_key]) {
				state[id_key] = {
					isError: false,
					isLoading: false,
					result: null,
				};
			}
			state[id_key].isError = isError;
		},
		setGeoJsonLoading: (state, action: PayloadAction<{
			format: GeoJsonFormat;
			id_key: string;
			ids: number[];
			isLoading: boolean;
			type: GeoJsonType;
		}>) => {
			const {
				id_key,
				isLoading,
			} = action.payload;
			if (!state[id_key]) {
				state[id_key] = {
					isError: false,
					isLoading: false,
					result: null,
				};
			}
			state[id_key].isLoading = isLoading;
		},
	},
});

export const {
	clearAllGeoJson,
	clearGeoJson,
	setGeoJson,
	setGeoJsonError,
	setGeoJsonLoading,
} = geoJsonSlice.actions;

export const geoJsonReducer = geoJsonSlice.reducer;
